import { Pipe, PipeTransform } from '@angular/core';
import { isString } from 'ionic-angular/util/util';

@Pipe({name: 'kgTranslate'})
export class TranslatePipe implements PipeTransform {
  map: Map<string, string>;

  constructor() {
    this.map = new Map([
      ['AERIEN', 'Aérien'],
      ['BIGGESTRANGE', 'Projection moyennée'],
      ['COURBE', 'Courbe'],
      ['DROITE', 'Droit'],
      ['FLEXIONTOTALE', 'Totale'],
      ['FLEXIONTOTALEPLASTIQUE', 'Totale Plastique'],
      ['FLEXIONTOTALEKD', 'Totale*Kd'],
      ['GEOGRAPHICLOCATION', 'Situation géographique'],
      ['MONITOR_TIME', 'A surveiller'],
      ['ERROR', 'En erreur'],
      ['NEGATIVE', 'Négatif'],
      ['OK', 'Bon'],
      ['ONE', '1'],
      ['OTHERVALUES', 'Mesures effectuées'],
      ['POSITIVE', 'Positif'],
      ['PROFILE', 'Profil'],
      ['REPLACE', 'A remplacer'],
      ['SMALLESTRANGE', 'Projection non moyennée'],
      ['STATIONNAME', 'Nom de station'],
      ['ALERTTHICKNESS', 'Epaisseur limite'],
      ['PESSIMISTICRANGE', 'Projection pessimiste'],
      ['STEEL', 'Type d\'acier'],
      ['TRACKALIGNMENT', 'Alignement'],
      ['TUNNEL', 'Tunnel'],
      ['TWO', '2']
    ])
  }

  transform(key: string): string {
    if(!isString(key)) {
      return '-';
    }
    return this.map.get(key.toUpperCase()) || key;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/translate.pipe.ts